import React, { useEffect, useState } from "react";
import { Button, Img, Input, Text, Radio, CheckboxCustom } from "components";
import { SuccessOrderPlaced } from "popups/SuccessOrderPlaced";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as CARDVALIDATION from "../../../../utils/helper/payfortValidation";
import globalRequest from "utils/global/globalRequest";
import * as APIS from "../../../../utils/helper/Enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "redux/reducers/snackbar";
import { changeTrigger } from "redux/reducers/trigger";
import { getAuth } from "redux/reducers/loginData";
import ApplePayComponent from "../../../ApplePayComponent/index.jsx";
import { useAppFont } from "utils/helper/useAppFont";

// ── Payment tab IDs ──────────────────────────────────────────────────────────
const TAB_CARD   = "card";
const TAB_TABBY  = "tabby";
const TAB_APPLEPAY  = "apple_pay";
// const TAB_WALLET = "wallet";   // kept for reference

const Payment = ({ setIsGiftPayment, orderData, setOrderDetails }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);

  // ── NEW: top-level tab selection (card vs tabby) ─────────────────────────
  const [activePaymentTab, setActivePaymentTab] = useState(TAB_CARD);

  // ── NEW: show inline "Add New Card" form ─────────────────────────────────
  const [showAddCard, setShowAddCard] = useState(false);

  // ── existing state ───────────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState(0);           // selected saved card index
  const [cardList, setCardList] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [cardError, setCardError] = useState({});
  const [cardTypeError, setCardTypeError] = useState({});
  let [cardData, setCardData] = useState({});
  const [paymentData, setPaymentData] = useState({});
  const [tabbyData, setTabbyData] = useState({});
  const [tabbyError, setTabbyError] = useState({});
  const [SuccessOrderPlacedOpen, setSuccessOrderPlacedOpen] = React.useState(false);
  const [showApplePayButton, setShowApplePayButton] = useState(false);
  const [applePayDetail, setApplePayDetail] = useState({});
  const [applePayEmail, setApplePayEmail] = useState("");
  const [applePayError, setApplePayError] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const [couponData, setCouponData] = useState({
    isApplied: false,
    couponCode: "",
    couponCodeId: "",
    discount: 0,
  });
  const { interClass, headingClass, interFamily, headingFamily} = useAppFont();

  const handleTabClick = (id) => {
    setCardError({});
    setCardTypeError({});
    setTabbyData({});
    setTabbyError({});
    setCardData({});
    setActiveTab(id);
  };

  /** get user wallet balance */
  const getWalletBalance = async () => {
    try {
      let response = await globalRequest(APIS.USERS.GET_WALLET_BALANCE, "get", {}, {}, true);
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setWalletBalance(response?.data?.wallet_balance);
      } else {
        setWalletBalance(0);
      }
    } catch (e) {
      setWalletBalance(0);
    }
  };

  /** Get saved card list */
  const getCardList = async () => {
    try {
      let response = await globalRequest(APIS.USERS.GET_SAVED_CARD_LIST, "get", {}, {}, true);
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setCardList(response?.data);
      } else {
        setCardList([]);
      }
    } catch (e) {
      setCardList([]);
    }
  };

  /** Check credit card type */
  const checkCartType = (cardNo) => {
    let res = CUSTOM.getCardType(cardNo);
    setCardTypeError(res);
  };

  const sendPurchaseGaEvent = async (order_number) => {
    try {
      let response = await globalRequest(
        APIS?.ORDER?.SEND_PURCHASE_GA_EVENT,
        "post",
        { order_number, gaData: CUSTOM.getGACookieValues() },
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        console.log("GA event sent");
      }
    } catch (e) {
      console.log(e?.message);
    }
  };

  /** payment process */
  const paymentProcess = async (type = "", applePayData, session) => {
    dispatch(changeLoader(true));
    try {
      let cDatas = {
        ...cardData,
        ...paymentData,
        card_security_code: cardData?.token_name ? cardData?.cvv : "",
        payment_method: type ? type : null,
        coupon_code_id: couponData?.couponCodeId ? couponData?.couponCodeId : "",
        coupon_code: couponData?.couponCode ? couponData?.couponCode : "",
      };
      if (type == "tabby") {
        cDatas.tabby_phone_number = tabbyData?.phone;
        cDatas.tabby_email = tabbyData?.email;
      }
      if (type == "apple_pay") {
        cDatas.applePayData = applePayData;
        cDatas.applePayEmail = applePayEmail;
      }
      let response = await globalRequest(APIS.GIFTORDER.GET_ORDER_PAYMENT, "post", cDatas, {}, true);
      response = response?.data;
      if (response?.status == "SUCCESS") {
        if (response?.data?.otp_link) {
          window.location.href = response?.data?.otp_link;
        }
        if (response?.data?.is_card) {
          let formId = document.getElementById("aps_payment_form");
          if (formId) {
            cardData = { ...cardData, ...response?.data };
            setCardData(cardData);
            setTimeout(() => { formId.submit(); }, 100);
          }
        } else if (response?.data?.is_tabby === 1) {
          let formId = document.getElementById("aps_payment_form_tabby");
          if (formId) {
            cardData = { ...tabbyData, ...response?.data };
            setTabbyData(cardData);
            setTimeout(() => { formId.submit(); }, 100);
          }
        } else {
          if (type == "apple_pay") {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
          }
        }
        if (response?.data?.order_number) {
          setPaymentData({ ...paymentData, order_number: response?.data?.order_number });
          sendPurchaseGaEvent(response?.data?.order_number);
          CUSTOM.sendPaymentStatusGaEvent("success", "order", auth?.id, orderData?.userDetails);
          setSuccessOrderPlacedOpen(true);
          setTimeout(() => {
            setIsGiftPayment(false);
            dispatch(changeTrigger("refetchDetails"));
          }, [2500]);
        }
      } else {
        if (type == "apple_pay") {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          CUSTOM.sendPaymentStatusGaEvent("failed", "order", auth?.id, orderData?.userDetails);
        }
        dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: response?.message, snackbarState: "error" }));
      }
    } catch (e) {
      if (type == "apple_pay") {
        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
      }
      dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: e?.message, snackbarState: "error" }));
    }
    dispatch(changeLoader(false));
  };

  /** Apply coupon code */
  const applyCouponCodeForGift = async () => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.COUPON?.APPLY_COUPON_CODE_FOR_GIFT,
        "get",
        {},
        { params: { coupon_code: couponCode ? couponCode.trim() : "", order_id: orderData?.id } },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setCouponData({
          isApplied: true,
          couponCode: couponCode.trim(),
          couponCodeId: response?.data?.data?.id,
          discount: response?.data?.coupon_discount_amount,
        });
        setOrderDetails((prev) => {
          let data = {
            ...prev?.orderData,
            priceDetails: {
              ...prev?.orderData?.priceDetails,
              total_amount: prev?.orderData?.priceDetails?.total_amount - response?.data?.coupon_discount_amount,
            },
          };
          return { ...prev, orderData: data };
        });
        CUSTOM.trackCouponApplied({ coupon_code: couponCode.trim() });
        setCouponCode("");
      } else {
        setCouponCodeError(response?.message);
      }
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  /** Remove coupon code */
  const removeCouponCode = () => {
    dispatch(changeLoader(true));
    setOrderDetails((prev) => {
      let data = {
        ...prev?.orderData,
        priceDetails: {
          ...prev?.orderData?.priceDetails,
          total_amount: prev?.orderData?.priceDetails?.total_amount + couponData?.discount,
        },
      };
      return { ...prev, orderData: data };
    });
    setCouponData({ ...couponData, isApplied: false, couponCode: "", couponCodeId: "", discount: 0 });
    setCouponCode("");
    dispatch(changeLoader(false));
  };

  /** Verify card */
  const verifyCard = () => {
    const newErrors = {};
    if (!cardData?.token_name) {
      if (cardData.card_number) {
        let resValidation = CARDVALIDATION.validateCard(cardData.card_number);
        if (!resValidation?.validity) {
          newErrors.card_number = t("cardNumberError");
        }
      } else {
        newErrors.card_number = t("cardNumberErrorEmpty");
      }
      if (cardData.expiration_date) {
        if (!CARDVALIDATION.validateExpiryDate(cardData.expiration_date)) {
          newErrors.date = t("cardDateError");
        }
      } else {
        newErrors.date = t("cardDateErrorEmpty");
      }
      if (!cardData.card_holder) {
        newErrors.card_holder = t("cardHolderError");
      } else {
        let cartHolderValidation = CARDVALIDATION.validateHolderName(cardData.card_holder);
        if (!cartHolderValidation?.validity) {
          newErrors.card_holder = t("cardNumberError");
        }
      }
    }
    if (cardData.cvv) {
      if (!cardData.cvv.match(/^\d{3,4}$/)) {
        newErrors.cvv = t("cvvNumberError");
      }
    } else {
      newErrors.cvv = t("cvvNumberErrorEmpty");
    }
    if (Object.keys(newErrors).length == 0) {
      if (!cardData?.token_name) {
        let expdata = cardData?.expiration_date.split("/");
        cardData.edate = `${expdata[1]}${expdata[0]}`;
        setCardData({ ...cardData, edate: `${expdata[1]}${expdata[0]}` });
      }
      paymentProcess("card");
    }
    setCardError(newErrors);
  };

  const verifyTabbyFields = () => {
    let newErrors = {};
    if (tabbyData?.email) {
      if (!CUSTOM.isValidField(tabbyData?.email, "email")) {
        newErrors.email = t("email_name_required");
      }
    } else {
      newErrors.email = t("email_name_required");
    }

    if (tabbyData?.phone) {
      if (tabbyData?.phone.length != 9) {
        newErrors.phone = t("mobile_no_length_error");
      }
    } else {
      newErrors.phone = t("mobile_no_required");
    }

    if (Object.keys(newErrors).length > 0) {
      setTabbyError(newErrors);
      return false;
    }
    paymentProcess("tabby");
  };

  const checkApplePayEmail = (email) => {
    if (email) {
      if (!CUSTOM.isValidField(email, "email")) {
        setApplePayError(t("please_enter_valid_email"));
      } else {
        setApplePayError("");
      }
    } else {
      setApplePayError(t("email_name_required"));
    }
  };

  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setShowApplePayButton(true);
    }
  }, []);

  useEffect(() => {
    getCardList();
    getWalletBalance();
  }, []);

  useEffect(() => {
    setPaymentData({ ...paymentData, order_id: orderData?.id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let applePayDataObj = {};
    if (paymentData?.iswallet) {
      applePayDataObj.amount = CUSTOM.setPrice(orderData?.priceDetails?.total_amount - walletBalance);
    } else {
      applePayDataObj.amount = CUSTOM.setPrice(orderData?.priceDetails?.total_amount);
    }
    setApplePayDetail(applePayDataObj);
  }, [orderData, paymentData?.iswallet, activePaymentTab]);

  // ── Helper: card logo ────────────────────────────────────────────────────
  const getCardLogo = (type) => {
    if (!type) return "/images/img_lightbulb.svg";
    const t = type.toLowerCase();
    if (t.includes("visa"))   return "/images/img_007visa.png";
    if (t.includes("master")) return "/images/img_023mastercard1.png";
    return "/images/img_lightbulb.svg";
  };

  // ── Computed: total amount to pay ────────────────────────────────────────
  const totalAmount = CUSTOM.setPrice(orderData?.priceDetails?.total_amount);

  return (
    <>
      {/* ── Hidden payfort forms (unchanged) ─────────────────────────────── */}
      <form
        method="post"
        action={`${process.env.REACT_APP_PAYFORT_MODE == "TEST" ? process.env.REACT_APP_PAYFORT_DEVLOPMENT : process.env.REACT_APP_PAYFORT_PRODUCTION}/FortAPI/paymentPage`}
        id="aps_payment_form"
        name="aps_payment_form"
        className="hidden"
      >
        <span dangerouslySetInnerHTML={{ __html: CUSTOM.paymentFormHtml(cardData) }}></span>
      </form>
      <form
        method="post"
        action={`${process.env.REACT_APP_PAYFORT_MODE == "TEST" ? process.env.REACT_APP_PAYFORT_DEVLOPMENT : process.env.REACT_APP_PAYFORT_PRODUCTION}/FortAPI/paymentPage`}
        id="aps_payment_form_tabby"
        name="aps_payment_form_tabby"
        className="hidden"
      >
        <span dangerouslySetInnerHTML={{ __html: CUSTOM.paymentFormHtmlTabby(tabbyData) }}></span>
      </form>

      {/* ── Error display ─────────────────────────────────────────────────── */}
      {couponCodeError ? <span className="red-error text-xs text-red-500 mb-2 block">{couponCodeError}</span> : ""}

      {/* ════════════════════════════════════════════════════════════════════
          NEW UI – matches images
         ════════════════════════════════════════════════════════════════════ */}
      <div className={`flex flex-col w-full gap-4 ${interClass}`}>

        {/* ── Tab Row: two separate bordered cards side by side (image-matched) ── */}
        <div className="flex flex-row gap-3">

          {/* ── Debit/Credit Card card ── */}
          <button
            onClick={() => { setActivePaymentTab(TAB_CARD); setShowAddCard(false); handleTabClick(0); }}
            className={`flex-1 flex flex-col items-start px-4 py-3 rounded-lg border transition-all text-left ${
              activePaymentTab === TAB_CARD
                ? "border-gray-300 bg-white shadow-sm"
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
          >
            {/* Label row */}
            <div className="flex items-center justify-between w-full mb-2">
              <span className={`text-sm font-medium text-gray-900 ${interClass}`}>
                {t("creditDebitCard") || "Debit/Credit Card"}
              </span>
              {/* Radio */}
              <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                activePaymentTab === TAB_CARD ? "border-[#8B1A4A]" : "border-gray-300"
              }`}>
                {activePaymentTab === TAB_CARD && (
                  <span className="w-2 h-2 rounded-full bg-[#8B1A4A]" />
                )}
              </span>
            </div>

            {/* Accepted Methods */}
            <div className="flex flex-row justify-between gap-1 w-full">
              <p className={`text-xs text-gray-400 ${interClass}`}>Accepted Methods</p>
              <div className="flex items-center gap-1.5 flex-wrap">
                <img src="/images/img_007visa.png"         alt="visa"       className="h-4 object-contain" />
                <img src="/images/img_file_white_a700.svg" alt="applepay"   className="h-4 object-contain" />
                <img src="/images/img_023mastercard1.png"  alt="mastercard" className="h-4 object-contain" />
                <img src="/images/img_1200pxrupaysvg.png"  alt="rupay"      className="h-4 object-contain" />
              </div>
            </div>
          </button>

          {/* ── Pay with Tabby card ── */}
          <button
            onClick={() => { setActivePaymentTab(TAB_TABBY); setShowAddCard(false); }}
            className={`flex-1 flex flex-col items-start px-4 py-3 rounded-lg border transition-all text-left ${
              activePaymentTab === TAB_TABBY
                ? "border-gray-300 bg-white shadow-sm"
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
          >
            {/* Label row */}
            <div className="flex items-center justify-between w-full mb-2">
              <span className={`text-sm font-medium text-gray-900 ${interClass}`}>
                {t("payWithTabby") || "Pay with Tabby"}
              </span>
              {/* Radio */}
              <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                activePaymentTab === TAB_TABBY ? "border-[#8B1A4A]" : "border-gray-300"
              }`}>
                {activePaymentTab === TAB_TABBY && (
                  <span className="w-2 h-2 rounded-full bg-[#8B1A4A]" />
                )}
              </span>
            </div>

            {/* Redirect note + Tabby logo */}
            <div className="flex items-center justify-between w-full">
              <p className={`text-xs text-gray-400 ${interClass}`}>
                {t("youWillBeRedirectedToTabby") || "You will be redirected to Tabby"}
              </p>
              <img src="/images/tabby/tabby-badge.png" alt="tabby" className="h-5 object-contain ml-2 flex-shrink-0" />
            </div>
          </button>
          
        </div>

        {/* ── Apple Pay card (only if device supports it) ── */}
          {showApplePayButton && (
            <button
              onClick={() => { setActivePaymentTab(TAB_APPLEPAY); setShowAddCard(false); }}
              className={`flex-1 flex flex-col items-start px-4 py-3 rounded-lg border transition-all text-left ${
                activePaymentTab === TAB_APPLEPAY
                  ? "border-gray-300 bg-white shadow-sm"
                  : "border-gray-200 bg-white hover:border-gray-300"
              }`}
            >
              {/* Label row */}
              <div className="flex items-center justify-between w-full mb-2">
                <span className={`text-sm font-medium text-gray-900 ${interClass}`}>
                  {t("payWithApplePay") || "Apple Pay"}
                </span>
                {/* Radio */}
                <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  activePaymentTab === TAB_APPLEPAY ? "border-[#8B1A4A]" : "border-gray-300"
                }`}>
                  {activePaymentTab === TAB_APPLEPAY && (
                    <span className="w-2 h-2 rounded-full bg-[#8B1A4A]" />
                  )}
                </span>
              </div>

              <div className="flex items-center justify-between w-full">
                <p className={`text-xs text-gray-400 ${interClass}`}>
                  {t("payQuicklyWithApplePay") || "Pay quickly with Apple Pay"}
                </p>
                <img src="/images/img_file_white_a700.svg" alt="applepay" className="h-5 object-contain ml-2 flex-shrink-0" />
              </div>
            </button>
          )}

        {walletBalance > 0 && (
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg">
            <div className="flex items-center gap-2 flex-1 flex-wrap">
              {/* amount badge */}
              <span className={`inline-flex items-center gap-1 text-sm font-semibold text-gray-900 ${interClass}`}>
                {t("pay") || "Pay"}
                <Img src="/images/Groupsar2.svg" className="w-3.5 h-3.5 inline-block" />
                {CUSTOM.setPrice(orderData?.priceDetails?.total_amount)}
              </span>
              <span className={`text-sm text-gray-600 ${interClass}`}>
                {t("payFromWalletBalance") || "Pay from wallet balance."}
              </span>
              <span className={`text-sm text-gray-500 ${interClass}`}>
                {t("availableCredit") || "Available Credit:"}{" "}
                <span className="font-medium text-gray-800 inline-flex items-center gap-0.5">
                  <Img src="/images/Groupsar2.svg" className="w-3 h-3 inline-block" />
                  {CUSTOM.setPrice(walletBalance)}
                </span>
              </span>
            </div>

            {/* iOS-style toggle */}
            <button
              type="button"
              role="switch"
              aria-checked={paymentData?.iswallet == 1}
              onClick={() => {
                setPaymentData({
                  ...paymentData,
                  iswallet: paymentData?.iswallet == 1 ? 0 : 1,
                });
              }}
              className={`relative flex-shrink-0 w-12 h-6 rounded-full transition-colors duration-200 focus:outline-none ${
                paymentData?.iswallet == 1 ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              <span
                className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-transform duration-200 ${
                  paymentData?.iswallet == 1 ? "translate-x-6" : "translate-x-0"
                }`}
              />
            </button>
          </div>
        )}

        {/* When wallet covers full amount – skip card/tabby panel, just show Pay ─ */}
        {paymentData?.iswallet == 1 && walletBalance >= orderData?.priceDetails?.total_amount ? (
          <div className="flex flex-col gap-3">
            <button
              onClick={() => paymentProcess("wallet")}
              className={`w-full py-3.5 rounded-lg bg-[#8B1A4A] hover:bg-[#7a1640] text-white text-sm font-semibold ${interClass} transition-colors`}
            >
              {t("payNow") || "Pay"}{" "}
              <span className="inline-flex items-center gap-1">
                <Img src="/images/Groupsar2.svg" className="w-3.5 h-3.5 inline-block" />
                {CUSTOM.setPrice(orderData?.priceDetails?.total_amount)}
              </span>
            </button>
            <p className={`text-center text-xs text-gray-400 ${interClass} flex items-center justify-center gap-1`}>
              <svg className="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              {t("100SecurePaymentsPoweredByRabbitHole") || "100% Secure payment powered by Rabbit Hole"}
            </p>
          </div>
        ) : (
        /* ════════════════════════════════════════════════════════════════
            CARD PANEL
           ════════════════════════════════════════════════════════════════ */
        activePaymentTab === TAB_CARD && (
          <div className="flex flex-col gap-3">

            {!showAddCard ? (
              <>
                {/* Saved Cards heading */}
                {cardList.length > 0 && (
                  <p className={`text-sm font-semibold text-gray-800 ${interClass}`}>
                    {t("savedCards") || "Saved Cards"}
                  </p>
                )}

                {/* Saved card list */}
                <div className="flex flex-col gap-2">
                  {cardList.map((item, index) => (
                    <label
                      key={`card-${index}`}
                      className={`flex items-center justify-between px-4 py-3 border rounded-xl cursor-pointer transition-all ${
                        activeTab === index
                          ? "border-[#8B1A4A] bg-pink-50"
                          : "border-gray-200 bg-white hover:border-gray-300"
                      }`}
                      onClick={() => handleTabClick(index)}
                    >
                      <div className="flex items-center gap-3">
                        {/* Radio */}
                        <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                          activeTab === index ? "border-[#8B1A4A]" : "border-gray-300"
                        }`}>
                          {activeTab === index && (
                            <span className="w-2 h-2 rounded-full bg-[#8B1A4A]" />
                          )}
                        </span>
                        <span className={`text-sm text-gray-900 ${interClass}`}>
                          {t("cardEndingIn") || "Card ending in"}{" "}
                          <span className="tracking-widest text-gray-500">••••</span>{" "}
                          {item?.cardNumber?.slice(-4)}
                        </span>
                      </div>
                      {/* Card logo */}
                      <img
                        src={getCardLogo(item?.type)}
                        alt={item?.type}
                        className="h-6 object-contain"
                      />
                    </label>
                  ))}
                </div>

                {/* CVV field for selected saved card */}
                {cardList[activeTab] && (
                  <div className="max-w-[200px]">
                    <Input
                      required
                      label={t("cvv")}
                      type="password"
                      value={cardData?.cvv || ""}
                      error={cardError?.cvv}
                      onChange={(e) => {
                        setCardData({
                          ...cardData,
                          token_name: cardList[activeTab]?.cardToken,
                          cvv: CUSTOM.strFormat(e.target.value, "max:4|number"),
                        });
                        setCardError({ ...cardError, cvv: "" });
                      }}
                    />
                  </div>
                )}

                {/* + Add New Card row */}
                <button
                  onClick={() => { setShowAddCard(true); setCardData({}); setCardError({}); }}
                  className={`flex items-center gap-2 px-4 py-3 border border-dashed border-gray-300 rounded-xl text-sm text-gray-600 hover:border-gray-400 hover:bg-gray-50 transition-all ${interClass}`}
                >
                  <span className="text-lg leading-none text-gray-400">+</span>
                  {t("AddNewCard") || "Add New Card"}
                </button>
              </>
            ) : (
              /* ── Inline Add New Card form ──────────────────────────── */
              <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                  <p className={`text-sm font-semibold text-gray-800 ${interClass}`}>
                    {t("addingNewCard") || "Adding new card"}
                  </p>
                  <button
                    onClick={() => { setShowAddCard(false); setCardData({}); setCardError({}); }}
                    className={`text-xs text-gray-500 hover:text-gray-700 ${interClass}`}
                  >
                    ✕ {t("cancel") || "Cancel"}
                  </button>
                </div>

                {/* Card holder */}
                <div className="flex flex-col gap-1">
                  <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                    {t("cardHolderName")} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("enterYourCardName") || "Enter your card name"}
                    value={cardData?.card_holder || ""}
                    onChange={(e) => {
                      setCardData({ ...cardData, card_holder: CUSTOM.strFormat(e.target.value, "text|max:50") });
                      setCardError({ ...cardError, card_holder: "" });
                    }}
                    className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors`}
                  />
                  {cardError?.card_holder && <span className="text-xs text-red-500">{cardError.card_holder}</span>}
                </div>

                {/* Card number */}
                <div className="flex flex-col gap-1">
                  <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                    {t("cardNumber")} <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="XXXX XXXX XXXX XXXX"
                      value={cardData?.card_number || ""}
                      onChange={(e) => {
                        checkCartType(e.target.value);
                        setCardData({ ...cardData, card_number: CUSTOM.strFormat(e.target.value, "number|max:16") });
                        setCardError({ ...cardError, card_number: "" });
                      }}
                      className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors pr-10`}
                    />
                    {cardTypeError?.image && (
                      <img src={cardTypeError.image} className="h-5 absolute right-3 top-1/2 -translate-y-1/2 object-contain" alt="card type" />
                    )}
                  </div>
                  {cardError?.card_number && <span className="text-xs text-red-500">{cardError.card_number}</span>}
                </div>

                {/* Expiry + CVV row */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1">
                    <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                      {t("expirationDate") || "Expiration Date"} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="MM/YY"
                      value={cardData?.expiration_date || ""}
                      onChange={(e) => {
                        setCardData({ ...cardData, expiration_date: CUSTOM.strFormat(e.target.value, "max:15|expiry_date") });
                        setCardError({ ...cardError, date: "" });
                      }}
                      className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors`}
                    />
                    {cardError?.date && <span className="text-xs text-red-500">{cardError.date}</span>}
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                      {t("cvv")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="password"
                      placeholder="•••"
                      value={cardData?.cvv || ""}
                      onChange={(e) => {
                        setCardData({ ...cardData, cvv: CUSTOM.strFormat(e.target.value, "max:4|number") });
                        setCardError({ ...cardError, cvv: "" });
                      }}
                      className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors`}
                    />
                    {cardError?.cvv && <span className="text-xs text-red-500">{cardError.cvv}</span>}
                  </div>
                </div>

                {/* Save card checkbox */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={cardData?.remember_me === "YES"}
                    onChange={(e) => setCardData({ ...cardData, remember_me: e.target.checked ? "YES" : "NO" })}
                    className="w-4 h-4 accent-[#8B1A4A]"
                  />
                  <span className={`text-sm text-gray-700 ${interClass}`}>
                    {t("saveCardDetailsForFuturePurpose") || "Save card for faster future payments."}
                  </span>
                </label>
              </div>
            )}

            {/* ── Pay button ────────────────────────────────────────────── */}
            <button
              onClick={verifyCard}
              className={`w-full py-3.5 rounded-lg bg-[#8B1A4A] hover:bg-[#7a1640] text-white text-sm font-semibold ${interClass} transition-colors mt-1`}
            >
              {t("payNow") || "Pay"}{" "}
              <span className="inline-flex items-center gap-1">
                <Img src="/images/Groupsar2.svg" className="w-3.5 h-3.5 inline-block" />
                {totalAmount}
              </span>
            </button>

            {/* ── 100% Secure text ─────────────────────────────────────── */}
            <p className={`text-center text-xs text-gray-400 ${interClass} flex items-center justify-center gap-1`}>
              <svg className="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              {t("100SecurePaymentsPoweredByRabbitHole") || "100% Secure payment powered by Rabbit Hole"}
            </p>
          </div>
        ))}

        {/* ════════════════════════════════════════════════════════════════
            TABBY PANEL  (hidden when wallet covers full amount)
           ════════════════════════════════════════════════════════════════ */}
        {activePaymentTab === TAB_TABBY &&
          !(paymentData?.iswallet == 1 && walletBalance >= orderData?.priceDetails?.total_amount) && (
          <div className="flex flex-col gap-3">
            <div className="grid grid-cols-2 xs:grid-cols-1 gap-3">
              <div className="flex flex-col gap-1">
                <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                  {t("Phone")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={t("Phone") || "Phone"}
                  value={tabbyData?.phone || ""}
                  onChange={(e) => {
                    setTabbyData({ ...tabbyData, phone: CUSTOM.strFormat(e.target.value, "max:9|number") });
                    setTabbyError({ ...tabbyError, phone: "" });
                  }}
                  className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors`}
                />
                {tabbyError?.phone && <span className="text-xs text-red-500">{tabbyError.phone}</span>}
              </div>
              <div className="flex flex-col gap-1">
                <label className={`text-xs font-medium text-gray-500 ${interClass}`}>
                  {t("Email")} <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={t("Email") || "Email"}
                  value={tabbyData?.email || ""}
                  onChange={(e) => {
                    setTabbyData({ ...tabbyData, email: CUSTOM.strFormat(e.target.value, "max:50|email") });
                    setTabbyError({ ...tabbyError, email: "" });
                  }}
                  className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-900 ${interClass} outline-none focus:border-[#8B1A4A] transition-colors`}
                />
                {tabbyError?.email && <span className="text-xs text-red-500">{tabbyError.email}</span>}
              </div>
            </div>

            {/* Pay button */}
            <button
              onClick={verifyTabbyFields}
              className={`w-full py-3.5 rounded-lg bg-[#8B1A4A] hover:bg-[#7a1640] text-white text-sm font-semibold ${interClass} transition-colors mt-1`}
            >
              {t("payNow") || "Pay"}{" "}
              <span className="inline-flex items-center gap-1">
                <Img src="/images/Groupsar2.svg" className="w-3.5 h-3.5 inline-block" />
                {totalAmount}
              </span>
            </button>

            <p className={`text-center text-xs text-gray-400 ${interClass} flex items-center justify-center gap-1`}>
              <svg className="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              {t("100SecurePaymentsPoweredByRabbitHole") || "100% Secure payment powered by Rabbit Hole"}
            </p>
          </div>
        )}

        {/* ════════════════════════════════════════════════════════════════
            APPLE PAY PANEL
           ════════════════════════════════════════════════════════════════ */}
        {activePaymentTab === TAB_APPLEPAY &&
          !(paymentData?.iswallet == 1 && walletBalance >= orderData?.priceDetails?.total_amount) && (
          <div className="flex flex-col gap-3">
            <ApplePayComponent
              applePayData={applePayDetail}
              payViaOtherSource={paymentProcess}
              isApplePayEnabled={true}
            />

            <p className={`text-center text-xs text-gray-400 ${interClass} flex items-center justify-center gap-1`}>
              <svg className="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              {t("100SecurePaymentsPoweredByRabbitHole") || "100% Secure payment powered by Rabbit Hole"}
            </p>
          </div>
        )}
      </div>

      {/* ════════════════════════════════════════════════════════════════════
          OLD UI – all commented, not removed
         ════════════════════════════════════════════════════════════════════
      <div className="relative flex flex-col w-full">
        <div className="flex flex-row xs:flex-col xs:items-start gap-4 items-center justify-between w-full mb-4 ">
          <div className="flex flex-col gap-1 items-start justify-start flex-1">
            <Text className="text-base text-black-900 font-nunitomedium">{t("payment")}</Text>
            <div className="flex gap-1 flex-row items-center">
              <Text className="text-black-900 text-sm font-nunitoregular">{t("selectAnOptionToPay")}</Text>
            </div>
          </div>
          <Text className="text-black-900 text-md font-nunitomedium">{t("sar")} {orderData?.priceDetails?.total_amount}</Text>
        </div>
        {!couponData?.isApplied && (
          <div className="bg-white-A700 border border-gray-300 border-solid flex flex-row items-center justify-between">
            ... coupon input ...
          </div>
        )}
        {couponData?.isApplied ? ( ... ) : null}
        <div className="flex flex-col items-center justify-between w-full mt-2">
          <div className="flex flex-row items-start justify-start w-full pb-3.5 border-b border-solid border-gray-300 ">
            <CheckboxCustom ... />  wallet checkbox
            ...
          </div>
        </div>
        ... old card list, new card form, tabby, apple pay ...
        <div className="bg-red-50_01 ... payment-secure-box">
          ... secure payment strip ...
        </div>
      </div>
      */}

      {SuccessOrderPlacedOpen === true ? (
        <SuccessOrderPlaced
          closepopup={setSuccessOrderPlacedOpen}
          orderNumber={paymentData?.order_number}
        />
      ) : null}
    </>
  );
};

export default Payment;
